<app-page
  pageTitle="Moj profil"
  pageDescription="Upravljanje profilom"
  [showDivider]="true"
>
  <div class="profile-container mt-5">
    <section class="profile-section">
      <div class="profile-section__label">
        <div class="text-sm-semibold text-gray-900">Podaci za prijavu</div>
      </div>
      <div class="profile-section__content">
        <app-field label="Email" for="profile-email">
          <app-email-input
            [formCtrl]="emailCtrl"
            formCtrlId="profile-email"
            [isDisabled]="true"
            [hideErrors]="true"
          ></app-email-input>
        </app-field>

        <app-field label="Lozinka" for="profile-password">
          <app-text-input
            [hasIcon]="true"
            formCtrlType="password"
            formCtrlId="profile-password"
            [formCtrl]="passwordCtrl"
            [isDisabled]="true"
            [hideErrors]="true"
          >
            <app-lock-03 stroke="#ADB0B8"></app-lock-03>
          </app-text-input>
        </app-field>

        <app-button
          [btnSeverity]="ButtonSeverity.LINK"
          (btnClicked)="openChangePassword()"
        >
          <span>Promeni lozinku</span>
          <app-chevron-right class="link-chevron" stroke="#2970FF" width="7px" height="12px"></app-chevron-right>
        </app-button>
      </div>
    </section>

    <hr class="profile-divider" />

    <div class="logout-action">
      <app-button
        [btnSize]="ButtonSize.MD"
        [btnSeverity]="ButtonSeverity.OUTLINE"
        [isDestructive]="true"
        (btnClicked)="logout()"
      >
        <i class="pi pi-sign-out"></i>
        <span class="text-sm-semibold ml-2">Odjavi se</span>
      </app-button>
    </div>
  </div>

  <app-change-password-dialog
    [(isVisible)]="changePasswordDialogVisible"
  ></app-change-password-dialog>
</app-page>
